<template>
    <div>
        <Layout>
            <div class="row form__common--center">
                <div class="col-lg-12">
                    <div class="card mb-0" style="min-height: calc(100vh - 230px)">
                        <div v-if="isLoading" class="d-flex justify-content-center py-5">
                            <LoadingIcon />
                        </div>
                        <template v-else>
                            <template
                                v-if="
                                    !isActiveManagerData &&
                                    !isActiveDownloadData &&
                                    !isActiveMailSendData &&
                                    !isActiveSerialData &&
                                    !isActiveSearchSerialCode
                                "
                            >
                                <h3
                                    v-b-tooltip.hover="`（${formDetail?.name}）`"
                                    class="text-truncate"
                                    style="position: absolute; top: -40px; left: 40px"
                                >
                                    （{{ formDetail?.name }}）
                                </h3>
                                <div class="card-header">
                                    <div class="title--screen" style="white-space: nowrap">
                                        {{ $t('managerForm.analytics.dataManipulation') }}
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div
                                        style="
                                            width: 100%;
                                            border: 1px solid #dbdbdb;
                                            border-radius: 4px;
                                            -webkit-border-radius: 4px;
                                            -moz-border-radius: 4px;
                                            box-shadow: 0px 2px 1px #c9c9c9;
                                            padding: 20px;
                                        "
                                    >
                                        <!-- <div class="form-group row align-items-center">
                                        <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                            <button class="btn btn-common btn-outline-success" @click="onOpenScreenDownload" type="button">
                                                <i class="ri-file-download-line"></i>{{ $t('managerForm.analytics.downloadData') }}
                                            </button>
                                        </div>
                                        <div class="col-sm-9">回答データをCSV/XLSX形式でダウンロードできます｡</div>
                                    </div> -->
                                        <div v-if="formDetail.type !== ID_PAGE_TYPE.B" class="form-group row align-items-center">
                                            <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                                <button class="btn btn-common btn-outline-success" @click="onOpenScreenManagement" type="button">
                                                    <i class="ri-settings-3-line"></i>{{ $t('managerForm.analytics.dataManagement') }}
                                                </button>
                                            </div>
                                            <div class="col-sm-9">回答データや一時保存データの閲覧を行うことができます｡</div>
                                        </div>
                                        <div v-if="formDetail.type === ID_PAGE_TYPE.I" class="form-group row">
                                            <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                                <button class="btn btn-common btn-outline-success" @click="onOpenScreenMailSendData" type="button">
                                                    <i class="ri-mail-line"></i>{{ $t('managerForm.analytics.dataMailSend') }}
                                                </button>
                                            </div>
                                            <div class="col-sm-9"><span></span></div>
                                        </div>
                                        <div v-if="formDetail.type === ID_PAGE_TYPE.B" class="form-group row">
                                            <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                                <button
                                                    class="btn btn-common btn-outline-success"
                                                    @click="onOpenScreenSearchSerialCode"
                                                    type="button"
                                                >
                                                    <i class="ri-search-line"></i>{{ $t('managerForm.analytics.searchSerialCode') }}
                                                </button>
                                            </div>
                                            <div class="col-sm-9"></div>
                                        </div>
                                        <div v-if="formDetail.type === ID_PAGE_TYPE.B" class="form-group row">
                                            <div class="col-sm-2 text-nowrap" style="min-width: 220px">
                                                <button class="btn btn-common btn-outline-success" @click="onOpenScreenSerialCode" type="button">
                                                    <i class="ri-code-line"></i>{{ $t('managerForm.analytics.dataSerialCode') }}
                                                </button>
                                            </div>
                                            <div class="col-sm-9"><span></span></div>
                                        </div>
                                        <template v-if="$route.query.id && checkPermission('form.delete_analytics')">
                                            <div class="form-group row">
                                                <label class="col-sm-2 text-nowrap" style="min-width: 220px; color: #339162; cursor: pointer">
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-danger"
                                                        @click="handleDeleteFormAndData({ id: $route.query.id })"
                                                    >
                                                        {{ $t('btn.deleteFormAndData') }}
                                                    </button></label
                                                >
                                                <div class="col-sm-9">
                                                    <span> {{ $t('managerForm.analytics.noteDeleteFormAndData') }} </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-2 text-nowrap" style="min-width: 220px; color: #339162; cursor: pointer">
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-danger"
                                                        @click="handleDeleteResultAnalytics({ id: $route.query.id })"
                                                    >
                                                        {{ $t('btn.deleteLogical') }}
                                                    </button></label
                                                >
                                                <div class="col-sm-9">
                                                    <span> {{ $t('managerForm.analytics.noteDeleteLogic') }} </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-2 text-nowrap" style="min-width: 220px; color: #339162; cursor: pointer">
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-danger"
                                                        @click="handleDeleteAllDataResult({ id: $route.query.id })"
                                                    >
                                                        {{ $t('btn.deleteAllData') }}
                                                    </button></label
                                                >
                                                <div class="col-sm-9">
                                                    <span> {{ $t('managerForm.analytics.noteDeleteAllData') }} </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <label class="col-sm-2 text-nowrap" style="min-width: 220px; color: #339162; cursor: pointer">
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-danger"
                                                        @click="handleDeletePermanently({ id: $route.query.id })"
                                                    >
                                                        {{ $t('btn.deletePermanently') }}
                                                    </button></label
                                                >
                                                <div class="col-sm-9">
                                                    <span> {{ $t('managerForm.analytics.noteDeletePermanently') }} </span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <ManagerData v-if="isActiveManagerData" :detailForm="formDetail" />
                            <DownloadData v-if="isActiveDownloadData" :detailForm="formDetail" />
                            <DataMailSend v-if="isActiveMailSendData" :detailForm="formDetail" />
                            <DataSerialCode v-if="isActiveSerialData" :detailForm="formDetail" />
                            <SearchSerialCode v-if="isActiveSearchSerialCode" :detailForm="formDetail" />
                        </template>
                    </div>
                    <ModalListPreview
                        :formData="{
                            ...formDetail,
                            campaign_not_change: formDetail.campaign,
                            forms: formDetail.campaign_forms,
                            landing_pages: formDetail.campaign_lps
                        }"
                        :config.sync="configModalListPrv"
                    />
                </div>
            </div>
        </Layout>

        <ModalLoading
            id="ModalAnalyticsProccessing"
            :config="configModalProgressDeleteAnalytics"
            :isLoading="isProcessing"
            @close="() => (configModalProgressDeleteAnalytics.model = false)"
        />

        <Footer>
            <div style="display: grid; grid-template-columns: repeat(3, 1fr)">
                <div class="d-flex align-items-center" style="gap: 0.7rem">
                    <button type="submit" @click="onGotoList" class="btn btn-common-footer">
                        <i class="ri-list-check"></i>{{ $t('btn.backListForm') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-common btn-info"
                        style="min-width: 76px"
                        @click="onGoToDetail('/manager-form/view', $route.query.id)"
                    >
                        <i class="ri-arrow-left-line"></i>{{ $t('btn.goToDetail') }}
                    </button>
                    <button
                        v-if="isActiveManagerData || isActiveDownloadData || isActiveMailSendData || isActiveSerialData || isActiveSearchSerialCode"
                        type="button"
                        class="btn btn-common btn-primary"
                        @click="onBackScreen"
                        style="min-width: 76px"
                    >
                        <i class="ri-arrow-left-line"></i>{{ $t('managerForm.analytics.returnToAnalysis') }}
                    </button>
                </div>
                <div class="text-center">
                    <button type="button" class="btn btn-common-footer" @click="() => (configModalListPrv.model = true)">
                        <i class="ri-link-m"></i>{{ $t('pageCampaign.listLinkLPAndForm') }}
                    </button>
                </div>
            </div>
        </Footer>
    </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Footer from '@/components/Footer/main.vue';
import ManagerData from './components/manager-data/main.vue';
import DownloadData from './components/download-data/main.vue';
import DataMailSend from './components/data-mail-send/main.vue';
import DataSerialCode from './components/data-serial-code/main.vue';
import SearchSerialCode from './components/search-serial-code/main.vue';
import ModalListPreview from '@/views/pages/campaign/view/components/ModalListPreview/main.vue';
import runJobMinxin from '@/mixins/runJobMinxin';
import ModalLoading from '@/components/ModalLoading/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';

import { checkPermission } from '@/utils/handlers';
import { managerFormMethods } from '@/state/helpers';
import { onHandleShowConfirm } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';
import { ID_PAGE_TYPE } from '@/views/pages/phase2/manager-form/constants';
import { configs } from '@/views/pages/phase2/manager-form/analytics/constants';

export default {
    name: 'AnalyticsFormList',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        Footer,
        ManagerData,
        DownloadData,
        ModalListPreview,
        DataMailSend,
        DataSerialCode,
        SearchSerialCode,
        ModalLoading,
        LoadingIcon
    },
    mixins: [runJobMinxin],
    beforeRouteEnter(to, from, next) {
        if (!checkPermission('form.analytics')) {
            next({ name: 'errorPage' });
        }
        next();
    },
    data() {
        return {
            isLoading: true,
            isProcessing: false,
            isActiveManagerData: false,
            isActiveMailSendData: false,
            isActiveDownloadData: false,
            isActiveSerialData: false,
            isActiveSearchSerialCode: false,
            formDetail: {},
            configModalListPrv: {
                title: '',
                model: false,
                scrollable: true,
                hideFooter: false,
                centered: false,
                size: 'xl'
            },
            ID_PAGE_TYPE,
            configModalProgressDeleteAnalytics: configs.configModalProgressDeleteAnalytics
        };
    },
    methods: {
        checkPermission,
        ...managerFormMethods,

        onOpenScreenDownload() {
            this.isActiveDownloadData = true;
        },

        onOpenScreenManagement() {
            this.isActiveManagerData = true;
        },
        onOpenScreenMailSendData() {
            this.isActiveMailSendData = true;
        },
        onOpenScreenSerialCode() {
            this.isActiveSerialData = true;
        },
        onOpenScreenSearchSerialCode() {
            this.isActiveSearchSerialCode = true;
        },

        onBackScreen() {
            this.isActiveMailSendData = false;
            this.isActiveManagerData = false;
            this.isActiveDownloadData = false;
            this.isActiveSerialData = false;
            this.isActiveSearchSerialCode = false;
        },
        onGoToDetail(path, id) {
            this.$router.push({ path: path, query: { id: id } });
        },

        onGotoList() {
            this.$router.push({ name: 'ManagerFormList' });
        },

        async getDetailFormAnalytics() {
            if (!this.$route?.query?.id) {
                this.isLoading = false;
                return;
            }
            try {
                const response = await this.getDetailManagerForm(this.$route.query.id);
                if (response.type === ID_PAGE_TYPE.C) {
                    this.$router.push({ name: 'errorPage' });
                    return;
                }
                this.formDetail = response;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async handleDeleteFormAndData(payload) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'フォームとデータを削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                try {
                    this.configModalProgressDeleteAnalytics.model = true;
                    this.isProcessing = true;
                    const responseFormAndData = await this.deleteFormAndData(payload);
                    if (responseFormAndData.code !== 200) {
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        return;
                    }

                    if (responseFormAndData?.data && responseFormAndData?.data?.batch_id) {
                        let successCallback = async () => {
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                            this.$router.push({ path: '/manager-form/list' }).then(() => {
                                showMessage(200, this.$bvToast, '削除されました。');
                            });
                        };
                        let errorCallback = (res) => {
                            showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                        };
                        await this.startPollingJobStatus(
                            {
                                form_id: this.formDetail?.id,
                                batch_id: responseFormAndData?.data?.batch_id
                            },
                            successCallback,
                            errorCallback,
                            {
                                ...responseFormAndData?.data
                            },
                            'deleteS3Analytics'
                        );
                    } else {
                        showMessage(responseFormAndData?.code || 200, this.$bvToast, this.$t(responseFormAndData?.message || 'system.error'));
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        this.$router.push({ path: '/manager-form/list' }).then(() => {
                            showMessage(responseFormAndData?.code, this.$bvToast, '削除されました。');
                        });
                    }
                } catch (error) {
                    this.isProcessing = false;
                    this.configModalProgressDeleteAnalytics.model = false;
                    console.log('error', error);
                }
            }
        },
        async handleDeleteResultAnalytics(payload) {
            const confirmDelete = await onHandleShowConfirm({
                title: '応募者データのみ削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                try {
                    this.configModalProgressDeleteAnalytics.model = true;
                    this.isProcessing = true;
                    const response = await this.deleteAllResultAnalytics(payload);
                    if (response.code !== 200) {
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        return;
                    }

                    if (response?.data && response?.data?.batch_id) {
                        let successCallback = async () => {
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                            this.$router.push({ path: '/manager-form/list' }).then(() => {
                                showMessage(200, this.$bvToast, '削除されました。');
                            });
                        };
                        let errorCallback = (res) => {
                            showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                        };
                        await this.startPollingJobStatus(
                            {
                                form_id: this.formDetail?.id,
                                batch_id: response?.data?.batch_id
                            },
                            successCallback,
                            errorCallback,
                            {
                                ...response?.data
                            },
                            'deleteS3Analytics'
                        );
                    } else {
                        showMessage(response?.code || 200, this.$bvToast, this.$t(response?.message || 'system.error'));
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        this.$router.push({ path: '/manager-form/list' }).then(() => {
                            showMessage(response?.code, this.$bvToast, '削除されました。');
                        });
                    }
                } catch (error) {
                    this.isProcessing = false;
                    this.configModalProgressDeleteAnalytics.model = false;
                    console.log('error', error);
                }
            }
        },

        async handleDeleteAllDataResult(payload) {
            const confirmDelete = await onHandleShowConfirm({
                title: ' 応募者データを完全削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                try {
                    this.configModalProgressDeleteAnalytics.model = true;
                    this.isProcessing = true;
                    const response = await this.deletePermanentlyResultAnalytics(payload);
                    if (response.code !== 200) {
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        return;
                    }

                    if (response?.data && response?.data?.batch_id) {
                        let successCallback = async () => {
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                            this.$router.push({ path: '/manager-form/list' }).then(() => {
                                showMessage(200, this.$bvToast, '削除されました。');
                            });
                        };
                        let errorCallback = (res) => {
                            showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                        };
                        await this.startPollingJobStatus(
                            {
                                form_id: this.formDetail?.id,
                                batch_id: response?.data?.batch_id
                            },
                            successCallback,
                            errorCallback,
                            {
                                ...response?.data
                            },
                            'deleteS3Analytics'
                        );
                    } else {
                        showMessage(response?.code || 200, this.$bvToast, this.$t(response?.message || 'system.error'));
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        this.$router.push({ path: '/manager-form/list' }).then(() => {
                            showMessage(response?.code, this.$bvToast, '削除されました。');
                        });
                    }
                } catch (error) {
                    this.isProcessing = false;
                    this.configModalProgressDeleteAnalytics.model = false;
                    console.log('error', error);
                }
            }
        },
        async handleDeletePermanently(payload) {
            const confirmDelete = await onHandleShowConfirm({
                title: 'フォームと応募者データを完全削除します。よろしいですか。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDelete) {
                try {
                    this.configModalProgressDeleteAnalytics.model = true;
                    this.isProcessing = true;
                    const response = await this.deletePermanently(payload);
                    if (response.code !== 200) {
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        return;
                    }

                    if (response?.data && response?.data?.batch_id) {
                        let successCallback = async () => {
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                            this.$router.push({ path: '/manager-form/list' }).then(() => {
                                showMessage(200, this.$bvToast, '削除されました。');
                            });
                        };
                        let errorCallback = (res) => {
                            showMessage(400, this.$bvToast, this.$t(res?.data?.error_message || 'system.error'));
                            this.isProcessing = false;
                            this.configModalProgressDeleteAnalytics.model = false;
                        };
                        await this.startPollingJobStatus(
                            {
                                form_id: this.formDetail?.id,
                                batch_id: response?.data?.batch_id
                            },
                            successCallback,
                            errorCallback,
                            {
                                ...response?.data
                            },
                            'deleteS3Analytics'
                        );
                    } else {
                        showMessage(response?.code || 200, this.$bvToast, this.$t(response?.message || 'system.error'));
                        this.isProcessing = false;
                        this.configModalProgressDeleteAnalytics.model = false;
                        this.$router.push({ path: '/manager-form/list' }).then(() => {
                            showMessage(response?.code, this.$bvToast, '削除されました。');
                        });
                    }
                } catch (error) {
                    this.isProcessing = false;
                    this.configModalProgressDeleteAnalytics.model = false;
                    console.log('error', error);
                }
            }
        }
    },
    mounted() {
        this.getDetailFormAnalytics();
    }
};
</script>

<style lang="scss" scoped></style>
